import { dataSettings } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSettings = /*#__PURE__*/createIcon(dataSettings)
export default IconSettings
